/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity } from '@gh/core-data';
import { ContactListItemMapper } from '../../contacts';
import { JobWarrantyTaskDto } from './job-warranty.dto';

export const jobWarrantyTaskMapper = entity<JobWarrantyTaskDto>({
  enteredDate: date(DateFormat.Date),
  toBeCompletedDate: date(DateFormat.Date),
  completedDate: date(DateFormat.Date),
  supplier: ContactListItemMapper,
});
